import { DocHeading, DocPage, DocParagraph, DocScrollTable } from "../DocElements";

const ROLE_COLUMNS = [{ label: "ロール", nowrap: true }, { label: "できること" }];

const ROLE_ROWS = [
	{
		key: "member",
		cells: [
			"メンバー",
			"追加されたプロジェクトの閲覧と、そのプロジェクトのエージェントとのチャット。それ以外の操作は、管理者から付与された権限の範囲で行えます",
		],
	},
	{
		key: "admin",
		cells: [
			"管理者",
			"組織内のすべてのプロジェクトへのアクセスと、すべての操作。ユーザーの招待・無効化と、ロールや権限の変更も行えます",
		],
	},
];

const PERMISSION_COLUMNS = [{ label: "権限", nowrap: true }, { label: "できること" }];

const PERMISSION_ROWS = [
	{
		key: "manageProjects",
		cells: [
			"プロジェクト管理",
			"プロジェクトの作成と、追加されたプロジェクトの編集・アーカイブ・メンバー管理",
		],
	},
	{
		key: "manageAgents",
		cells: [
			"エージェント管理",
			"エージェントの作成・編集・削除・起動・停止・再起動 (シークレットや共有ボリュームの設定を含む)",
		],
	},
	{
		key: "manageSharedVolumes",
		cells: ["共有ボリューム管理", "共有ボリュームの作成・削除"],
	},
	{ key: "runTraining", cells: ["学習", "学習ジョブの起動・中止"] },
];

export function RolesPage() {
	return (
		<DocPage title="ロールと権限">
			<DocParagraph>
				Izanagiに登録されたユーザーには、「メンバー」と「管理者」のどちらかのロールが割り当てられます。ロールによっては、アプリ内でできることが制限される場合があります。
			</DocParagraph>
			<DocScrollTable columns={ROLE_COLUMNS} rows={ROLE_ROWS} />
			<DocHeading>ユーザー権限</DocHeading>
			<DocParagraph>
				「組織」の「ユーザー」タブの「ユーザーを招待」で、下記の権限にチェックを入れることで、アプリのどの機能を操作できるかを調整できます。招待した後も、ユーザーの行の右端の「︙」から「ロールと権限を編集」でいつでも変更できます。管理者のユーザーはすべての権限を持っているため、権限を個別に設定することはできません。
			</DocParagraph>
			<DocScrollTable columns={PERMISSION_COLUMNS} rows={PERMISSION_ROWS} />
		</DocPage>
	);
}
